import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LogoComponent } from './components/logo/logo.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { NotificationContainerComponent } from './components/notification-container/notification-container.component';
import { PartnerInfoSelectorComponent } from './components/partner-info-selector/partner-info-selector.component';
import { UserProfileDropdownComponent } from './components/user-profile-dropdown/user-profile-dropdown.component';
import { ApiService, UserService, ProfileService, AuthService, CookiesService, OidcService } from './services';
import { HttpTokenInterceptor, ResponseInterceptor } from './interceptors';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { HomeMaterialModule } from '../home/home-material/home-material.module';
import { MatProgressSpinnerModule } from '@angular/material';
import { UiModule } from '../shared/ui/ui.module';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LogoComponent,
    LanguageSelectorComponent,
    NotificationContainerComponent,
    PartnerInfoSelectorComponent,
    UserProfileDropdownComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule,
    MatIconModule,
    MatSelectModule,
    TranslateModule,
    HomeMaterialModule,
    MatAutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    UiModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    NotificationContainerComponent
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
    ApiService,
    UserService,
    ProfileService,
    AuthService,
    CookiesService,
    OidcService
  ],
  
  entryComponents:[]
})
export class CoreModule { }
